/**
 * External URLs specific to the A2A consent flow — sourced from envConfig.
 * Shared URLs (privacy policy, terms of use) live in ../shared/urls.ts.
 */

import { getConfig } from '../../../config/envConfig';

const { a2a } = getConfig();

/** Documentation page for A2A / Rovo agents. */
export const A2A_DOC_URL = a2a.docUrl;
